export enum FeatureFlagColor {
  BERRY = 'berry',
  LIME_LIGHT = 'lime-light'
}
